import React from 'react';

import { ScrollRestoration } from 'react-router';

import type { BreadcrumbLink } from '@helsenorge/core-framework/breadcrumb';
import PageRoot from '@helsenorge/core-framework/pageroot';
import { getPath, getSidetittelId } from '@helsenorge/framework-utils/hn-page';
import { getVisPersonvelger } from '@helsenorge/framework-utils/hn-user';
import { CommonEvents } from '@helsenorge/framework-utils/web-component/constants';
import { HNeventSetHiddenPromopanel, useEventListener } from '@helsenorge/framework-utils/web-component/events';

interface Props {
  pageClass: string;
  breadcrumbLink?: BreadcrumbLink;
  hasFullwidth?: boolean;
}

const PageContainer: React.FunctionComponent<React.PropsWithChildren<Props>> = ({ children, pageClass, breadcrumbLink, hasFullwidth }) => {
  const webcomppromopanel = document.querySelector('hn-webcomp-cms-block-promopanel');
  const visPersonvelger = getVisPersonvelger();

  useEventListener(CommonEvents.isMounted, webcomppromopanel, () => {
    HNeventSetHiddenPromopanel(!!visPersonvelger);
  });

  React.useEffect(() => {
    HNeventSetHiddenPromopanel(!!visPersonvelger);
  }, [visPersonvelger]);

  return (
    <PageRoot
      mainAriaLabelledby={getSidetittelId()}
      breadcrumbLink={breadcrumbLink}
      hasPageHeader={false}
      className={`vbs-main ${pageClass}`}
      hasFullwidth={hasFullwidth}
      redirectTo={`/${getPath()}`}
    >
      <ScrollRestoration />
      {children}
    </PageRoot>
  );
};
export default PageContainer;
